
import TrueOrFalse from './TrueOrFalse'
import FillInTheBlanks from './FillInTheBlanks'
import OpenQuestion from './OpenQuestion'
import MultipleChoice from './MultipleChoice'
import Matching from './Matching'

const handlers = {
  'true-or-false': TrueOrFalse,
  'fill-in-the-blanks': FillInTheBlanks,
  'open-question': OpenQuestion,
  'multiple-choice': MultipleChoice,
  'matching': Matching
}

export default handlers
